import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Subtle page-enter wrapper. Keyed on pathname so CSS animation replays on navigation.
 * Skip on high-frequency keyboard routes if added later.
 */
export function AnimatedPage({ children }) {
  const location = useLocation();
  return (
    <div key={location.pathname} className="pf-page-enter">
      {children}
    </div>
  );
}

export default AnimatedPage;
